import React from "react";
import MessageContainer from "./messageContainer";
import { MessagePartner, Message, MessagePartnerHash } from "../../types";
import { formatUserName } from "../../libs/formatName";

type Props = {
	partner: MessagePartner;
	partners: MessagePartnerHash;
	messages: Message[];
	observer?: IntersectionObserver;
	messageReadBy: { [key: string]: string[] };
	userId: string;
};

const MessageGroup = ({ partner, partners, messages, observer, messageReadBy, userId }: Props) => {
	return (
		<div className="messageGroup" data-my-message={partner.userId === userId}>
			<div className="name">{formatUserName(partner)}</div>
			{messages.map((message, key: number) => (
				<MessageContainer
					key={key}
					{...{
						message,
						partner,
						partners,
						observer,
						messageReadBy: messageReadBy[message.messageId],
						userId,
					}}
				/>
			))}
		</div>
	);
};

export default MessageGroup;
